import React from 'react'
import { Link } from 'react-router-dom';
import { Avatar, Badge, Card, CardActions, CardContent, CardHeader, CardMedia, Divider, IconButton, Tooltip, Typography } from '@mui/material'
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import { shareLink, defaultImageLink } from '../constants/links';
import parser from 'html-react-parser'
import { Delete } from '@mui/icons-material';
import "../style/blog.css"

export default function BlogCard({blog, authorDetailsNeeded, handleShareToast, deleteButtonNeeded=false, handleDelete}) {
    return(
        <>
        <div key={blog} className='blog-card'>
        <Card sx={{ maxWidth: 345, height: 450}}>
            {authorDetailsNeeded && 
                <Link className="userIcon" to={`/account/${blog.authorId}`}>
              <CardHeader
                avatar={
                    <Avatar sx={{ bgcolor: red[500] }} aria-label="blog">
                      {blog?.authorName && blog.authorName[0]}
                    </Avatar>
                }
                title={blog?.authorName?.trim()}
                subheader={blog?.readTime + " | " + blog?.publishedDate}
              />
            </Link>}
            <Link className='blogCard' to={`/blogs/${blog.blogId}`}>
              <CardMedia
                component="img"
                height="194"
                image={blog?.titleImage ? blog?.titleImage[1] : defaultImageLink}
                alt="Paella dish"
              />
              </Link>
              <div className='card-actions'>
              <CardActions sx={{height: "13vh" }}>
                <Badge color="error" badgeContent={blog?.likes} max={999}>
                <Tooltip title="Likes">
                  <IconButton sx={{ cursor: 'default' }} disableRipple={true}>
                    <FavoriteIcon />
                  </IconButton>
                  </Tooltip>
                </Badge>
                <Tooltip title="Share">
                  <IconButton aria-label="share" onClick={()=>{handleShareToast("Link Copied!"); navigator.clipboard.writeText(shareLink+blog?.blogId)}}>
                    <ShareIcon />
                  </IconButton>
                </Tooltip>
                {deleteButtonNeeded && 
                  <Tooltip title="Delete">
                  <IconButton aria-label="delete" onClick={()=>handleDelete(blog.blogId)} >
                    <Delete />
                  </IconButton>
                </Tooltip>
                }
              </CardActions>
              </div>
              <Divider sx={{borderTop: "1.5px solid #e1e1e1d1" }}/>
              <Link className='blogCard' to={`/blogs/${blog.blogId}`}>
              <div className='card-content'>
              <CardContent sx={{ fontSize: "1rem", height: "10vh" }}>
                <Typography variant="body2" color="text.secondary">
                  {blog?.content && parser(blog.content)}
                </Typography>
              </CardContent>
              </div>
            </Link>
          </Card>
          </div>
        </>
    )
}